<mat-sidenav-container class="sidenav-container bg-transparent" autosize hasBackdrop="false">
  <!-- Backdrop overlay that appears when sidebar is open -->
  <div class="sidebar-backdrop" 
       *ngIf="expanded" 
       (click)="onBackdropClick($event)"></div>
  
  <mat-sidenav #sidenav class="sidenav" mode="over" [opened]="expanded">
    <div class="display-flex-column">
      <div class="flex-centered-container-vr">
        <button class="margin-8-left close-side-bar-button" mat-icon-button (click)="closeDrawer()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <img (click)="redirectToHome()" [src]="logoSrc" class="fake-button header-logo padding-vr">
      </div>
      <mat-divider class="mat-divider margin-8-bottom"></mat-divider>
      <mat-nav-list>
        <ng-container *ngFor="let tab of headerItems">
          <a mat-list-item *ngIf="tab.visible === undefined ? true : tab.visible" [class.active]="tab.route === activeUrl"
            (click)="navigateToComponent(tab)">
            <span *ngIf="expanded" class="padding-left">{{ tab.label }}</span>
          </a>
        </ng-container>
      </mat-nav-list>

      <span class="spacer"></span>
    </div>
  </mat-sidenav>

  <div class="sidenav-content">
    <ng-content select="[sidnav-router-outlet]">
    </ng-content>
  </div>

</mat-sidenav-container>
